import api from '../config/axios';

export const loginApi = (idToken) => api.post('/auth/login', { idToken });
export const getMe = () => api.get('/auth/me');
export const updateMe = (data) => api.put('/auth/me', data);
